import "./list-with-text-block.scss";